import Ad from "../components/Ad";
import PleaseSupportUs from "../components/PleaseSupportUs";
import classNames from "classnames";
import { isPatron } from "../util/helpers";
import styles from "../styles/Leaderboard.module.scss";
import useCanRunAds from "../hooks/useCanRunAds";
import useDarkMode from "use-dark-mode";
import { useSelector } from "react-redux";
import { useState } from "react";

const Leaderboard = () => {
  const canRunAds = useCanRunAds();
  const darkMode = useDarkMode(false);
  const profile = useSelector((state) => state.firebase.profile);
  const [randomRoll, setRandomRoll] = useState(Math.random());

  if (isPatron(profile)) return null;

  const ad =
    !canRunAds || randomRoll < 0.5 ? (
      <PleaseSupportUs always height={90} width={728} />
    ) : randomRoll < 4 / 6 ? (
      <Ad id="archidekt" />
    ) : randomRoll < 5 / 6 ? (
      <Ad id="csb" />
    ) : (
      <Ad id="fabrec" />
    );

  return (
    <div
      className={classNames(styles.leaderboard, {
        [styles.dark]: darkMode.value,
      })}
    >
      {ad}
    </div>
  );
};

export default Leaderboard;
